import React from 'react';
import { Typography, Box, Link } from 'vindi-ds-components';
import Token from 'vindi-ds-tokens';
import styles from './styles';
import ScaffoldCard from './scaffold_card';

function generateLink(linkInfo, paddingInfo, labelInfo) {
  return (
    <Link href={linkInfo} style={{ padding: paddingInfo }}>
      <Typography variant='caption'>
        {labelInfo}
      </Typography>
    </Link>
  );
}

function CompleteCard({
  successTitle, completedMessage, completedLinkLabel, completedLink,
  additionalLink, additionalLabel, step, isCompleted,
}) {
  const CardFooter = () => (
    <Typography color='textSecondary' variant='body2'>
      {completedMessage}
      <CardLinks />
    </Typography>
  );

  const LinkComplementar = () => (
    <>
      <Typography display='inline' color='textSecondary' variant='body2'> ou </Typography>
      {generateLink(additionalLink, '0px', additionalLabel)}
    </>
  );
  const CardLinks = () => (
    <Box
      css={{ color: Token.color.brand.secondary[500].value, display: 'inline' }}
    >
      {generateLink(completedLink, '0px', completedLinkLabel)}
      {additionalLink && <LinkComplementar />}
    </Box>
  );

  return (
    <ScaffoldCard
      css={styles.complete}
      CardFooter={CardFooter}
      iconColor='#00AD1D'
      title={successTitle}
      step={step}
      isCompleted={isCompleted}
    />
  );
}

export default CompleteCard;
